import { render, staticRenderFns } from "./specialSchool.vue?vue&type=template&id=1d60c6c3&"
import script from "./specialSchool.vue?vue&type=script&lang=js&"
export * from "./specialSchool.vue?vue&type=script&lang=js&"
import style0 from "./specialSchool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports